module.exports = {
      id: "icon-open-in-new-usage",
      viewBox: "0 0 24.047 24.047",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-open-in-new",
      toString: function () {
        return this.url;
      }
    }